import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';

@Injectable()
export class SecureGuard implements CanActivate {
    privileges: any[];
    recordId: any;
    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (localStorage.getItem('currentUser')) {
            this.recordId = route.params.id;
            if (this.recordId) {
                let url = state.url;
                const index = url.lastIndexOf('/');
                if (index > 0) {
                    const newUrl = url.substring(0, index);
                    let data = JSON.parse(localStorage.getItem("currentRole"));
                    this.privileges = data.privileges;
                    const check = this.privileges.filter(x => newUrl.includes(x.pageUrl));
                    if (check.length > 0) {
                        return true;
                    } else {
                        this.router.navigate(['/404']);
                        return false;
                    }
                }
            } else {
                let data = JSON.parse(localStorage.getItem("currentRole"));
                this.privileges = data.privileges;
                const check = this.privileges.filter(x => state.url.includes(x.pageUrl));
                if (check.length > 0) {
                    return true;
                } else {
                    this.router.navigate(['/404']);
                    return false;
                }
            }
        } else {
            this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
            return false;
        }
    }
}